export { default as default } from './KitAmountInput';
